import http from '../../../common/utils/http'
import apiUtils from '../../../common/utils/apiUtils'
import { API_BASE_URL } from '../../../common/utils/commonUrl'

export default {
  getMemberDetail: () => {
    return http.get(`${API_BASE_URL}/api/wxoa/member/member/getUserMemberDetails`).then(
      function (result) {
        return apiUtils.getDataFormResponse(result)
      },
      function (error) {
        console.log('error', error)
      }
    )
  },
  getWXSignature: (url) => {
    return http.get(`${API_BASE_URL}/wx/api/open-data/wx-config`, { params: url }).then(
      function (result) {
        return result.data
      },
      function (error) {
        console.log('error', error)
      }
    )
  },
  cancelCoupon: (data) => {
    return http.post(`${API_BASE_URL}/api/wxoa/coupon/couponExample/sellCouponExample`, data).then(
      function (res) {
        return apiUtils.getDataFormCodeResponse(res)
      },
      function (err) {
        console.log('error', err)
      }
    )
  },
  commitApplication: (data) => {
    // wxoa/member/member/verificationUserMember
    return http.post(`${API_BASE_URL}/api/wxoa/member/member/verificationMember`, data).then(
      function (res) {
        return apiUtils.getDataFormCodeResponse(res)
      },
      function (err) {
        console.log('err', err)
      }
    )
  },
  getUserInfo: (data) => {
    return http.get(`${API_BASE_URL}/api/user/user-context`).then(
      function (res) {
        return apiUtils.getDataFormCodeResponse(res)
      },
      function (err) {
        console.log('error', err)
      }
    )
  },
  getApplicationConfig: (data) => {
    return http.get(`${API_BASE_URL}/api/sys/prop/typeId/10060/propName/memberConfig`).then(
      function (res) {
        return apiUtils.getDataFormCodeResponse(res)
      },
      function (err) {
        console.log('error', err)
      }
    )
  },
  getCaptcha: (data) => {
    return http.get(API_BASE_URL + '/api/wxoa/member/member/sendVerificationCode', { params: data }).then(
      function (res) {
        return apiUtils.getDataFormResponse(res)
      },
      function (res) {
        console.log('error', res)
      }
    )
  },
  getCaptchaAuthNew: (data) => {
    return http.get(API_BASE_URL + '/api/wxoa/member/member/sendVerificationCodeStranger', { params: data }).then(
      function (res) {
        return apiUtils.getDataFormResponse(res)
      },
      function (res) {
        console.log('error', res)
      }
    )
  },
  uploadFileGetVinCode: (data) => {
    return http.post(API_BASE_URL + '/api/ocr/vehicle-license', { imageBase64: data }).then(
      function (res) {
        return apiUtils.getDataFormResponse(res)
      },
      function (res) {
        console.log('error', res)
      }
    )
  },
  deleteCarInfoById: (data) => {
    return http.patch(API_BASE_URL + '/api/wxoa/member/member/removeMemberCar?carId=' + data).then(
      function (res) {
        return apiUtils.getDataFormResponse(res)
      },
      function (res) {
        console.log('error', res)
      }
    )
  },
  getFinancialProjectInstance: (data) => {
    return http.get(API_BASE_URL + '/api/wxoa/coupon/couponExample/getFinancialProjectInstance', { params: data }).then(
      function (res) {
        return apiUtils.getDataFormResponse(res)
      },
      function (res) {
        console.log('error', res)
      }
    )
  },
  getStoredValueRecording: (data) => {
    return http.get(API_BASE_URL + '/api/wxoa/member/member/getStoredValueRecording', { params: data }).then(
      function (res) {
        return apiUtils.getDataFormResponse(res)
      },
      function (res) {
        console.log('error', res)
      }
    )
  },
  uploadFileGetMemberInfo: (data) => {
    return http.post(API_BASE_URL + '/api/bwc/ocr/ocr/id-card', { image: data }).then(
      function (res) {
        return apiUtils.getDataFormResponse(res)
      },
      function (res) {
        console.log('error', res)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/api/wx-member/member/member.js